import React, { useState, useEffect, useContext } from 'react';


import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, Card, theme, CheckBox } from 'antd';

import { DataContext } from '../../init/getData';
import toast from 'react-hot-toast';
import Loader from '../../components/loader/loader';
import Select from 'react-select';

function UserForm(props) {

  let { idRow, showModal, toggleModal, refreshTable } = props;


  const { userData, settingData, selectedCompany, api, refData, roleData } = useContext(DataContext);

  const userRole = userData.role;
  const createdBy = parseInt(userData.id);
  const companyId = selectedCompany.id;


  const [isLoading, setIsLoading] = useState(true);
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [user, setUser] = useState([]);
  const [validated, setValidated] = useState(false);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['role']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    if (showModal) {
      fetchData();
    }
  }, [showModal]);


  // idRow Change
  useEffect(() => {
    if (!isLoading) {
      setUser(
        {
          name: idRow?.name || '',
          roleId: idRow?.roleId || '',
          userName: idRow?.userName || '',
          password: idRow?.password || '',
          companyId: companyId,
        }
      )
    }
  }, [isLoading, idRow]);


  // Role Options
  const roleOptions = roleData?.map(item => ({
    value: item.id,
    label: item.name,
  }))



  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value)
    }
    setUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const closeModal = () => {
    refreshTable();
    toggleModal();
    setValidated(false);
    const form = document.getElementById('form');
    form.reset();
    setUser({
      companyId: companyId,
    })
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = document.getElementById('form');

    if (form.checkValidity() === false) {
      return;
    }
    setLoadingEffect(true);

    const data = {
      id: idRow?.id,
      user: user,
    }

    const operation = idRow ? 'edit' : 'add'
    try {
      let res = await api.post(`user/${operation}`, data);

      if (res.data.status) {
        toast.success(res.data.message);
        closeModal();
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Failed Contact Support");
    } finally {
      setLoadingEffect(false);
      setValidated(false);
    }
  }


  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setUser((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  };


  return (
    <Modal show={showModal} >

      <Modal.Header style={{ backgroundColor: '#23576a' }}>
        <Modal.Title style={{ color: 'white' }}>{idRow ? 'Edit ' : 'Add '}User</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {isLoading &&
          <Loader />
        }

        {!isLoading &&
          <Form validated={validated} id={'form'} onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} >

            <Row className="mb-3">

              <Col>
                <Form.Label >Name<span style={{ color: 'red' }}> *</span></Form.Label>
                <Form.Control type="text" name='name'
                  value={user.name}
                  onChange={handleInputChange}
                  required
                />
              </Col>

              <Col>
                <Form.Label >Role<span style={{ color: 'red' }}> *</span></Form.Label>
                <Select
                  options={roleOptions}
                  isSearchable={true}
                  placeholder="Select"
                  onChange={(e) => handleSelectChange(e, 'roleId')}
                  value={roleOptions?.find(option => option.value === user.roleId) || []}
                  required
                />
              </Col>
            </Row>

            <Row className="mb-5">

              <Col>
                <Form.Label >UserName<span style={{ color: 'red' }}> *</span></Form.Label>
                <Form.Control type="text" name='userName'
                  value={user.userName}
                  onChange={handleInputChange}
                  required
                />
              </Col>

              <Col>
                <Form.Label >Passowrd<span style={{ color: 'red' }}> *</span></Form.Label>
                <Form.Control type="text" name='password'
                  value={user.password}
                  onChange={handleInputChange}
                  required
                />
              </Col>
            </Row>




            <div className="modal-footer" style={{ textAlign: 'right' }}>
              <Button type="primary" onClick={closeModal} danger>Close</Button>
              <Button type="primary" loading={loadingEffect} htmlType="submit"
                onClick={() => setValidated(true)}
                style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>Save</Button>
            </div>

          </Form>
        }

      </Modal.Body>

    </Modal >
  )
}

export default UserForm;
